module.exports = import('https://lob.quest2travel.in/q2t-AI/remoteEntry.js');